import AttrPlugin from 'gsapAlias/AttrPlugin'
import CSSPlugin from 'gsapAlias/CSSPlugin'
import TimelineLite from 'gsapAlias/TimelineLite'
import TweenLite from 'gsapAlias/TweenLite'

// eslint-disable-next-line no-unused-vars
const plugins = [CSSPlugin, AttrPlugin]

export const chartFadeIn = (() => {
  const timeline = new TimelineLite()

  return ({
    circlesRef,
    numbersRef,
    dateRef,
    lineRef,
    dottedLinesRef,
    verticalLine1,
    verticalLine2,
    verticalLine3,
    circleY1,
    circleY2,
    isDesktop,
  }) => {
    timeline.clear().restart()

    const getNodes = arr => arr.map(item => item.current)
    const circleTime = {
      big: !isDesktop ? 0.1 : 0.2,
      normal: !isDesktop ? 0.15 : 0.2,
    }
    const fadeInTime = 0.1
    const lineTime = !isDesktop ? 0.2 : 0.3

    const fadeIn = (circle, number, date, dottedLine) => {
      timeline.fromTo(
        circle,
        circleTime.big,
        { attr: { r: 0 } },
        { attr: { r: 6 } },
      )
      timeline.to(circle, circleTime.normal, { attr: { r: 4 } })

      timeline.add([
        TweenLite.fromTo(
          number,
          fadeInTime,
          { attr: { opacity: 0 } },
          { attr: { opacity: 1 } },
        ),
        TweenLite.fromTo(
          date,
          fadeInTime,
          { attr: { opacity: 0 } },
          { attr: { opacity: 1 } },
        ),
        TweenLite.fromTo(
          dottedLine,
          fadeInTime,
          { attr: { opacity: 0 } },
          { attr: { opacity: 0.2 } },
        ),
      ])
    }

    const lineTo = (line, x2Start, y2Start, x2, y2) => {
      timeline.fromTo(
        line,
        lineTime,
        { attr: { x2: x2Start, y2: y2Start } },
        { attr: { x2, y2 } },
      )
    }

    const [circle1, circle2, circle3] = getNodes(circlesRef)
    const [number1, number2, number3] = getNodes(numbersRef)
    const [date1, date2, date3] = getNodes(dateRef)
    const [line1, line2] = getNodes(lineRef)
    const [dottedLine1, dottedLine2, dottedLine3] = getNodes(dottedLinesRef)

    if (circle1 && number1 && date1 && line1 && dottedLine1) {
      fadeIn(circle1, number1, date1, dottedLine1)
      lineTo(line1, verticalLine1, circleY1, verticalLine2, 35)

      fadeIn(circle2, number2, date2, dottedLine2)
      lineTo(line2, verticalLine2, circleY2, verticalLine3, 55)

      fadeIn(circle3, number3, date3, dottedLine3)
    }
  }
})()
